var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsOptional } from "class-validator";
import { BillingMode } from "../../billing/billing-mode";
export class SepaDebitDTO {
}
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], SepaDebitDTO.prototype, "last4", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], SepaDebitDTO.prototype, "country", void 0);
export class BillingDetailsDTO {
}
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], BillingDetailsDTO.prototype, "name", void 0);
export class PaymentMethodDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PaymentMethodDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", SepaDebitDTO)
], PaymentMethodDTO.prototype, "sepa_debit", void 0);
__decorate([
    Expose(),
    __metadata("design:type", BillingDetailsDTO)
], PaymentMethodDTO.prototype, "billing_details", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PaymentMethodDTO.prototype, "created", void 0);
export class InvoiceSettingsDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], InvoiceSettingsDTO.prototype, "default_payment_method", void 0);
export class StripeCustomerDTO {
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], StripeCustomerDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], StripeCustomerDTO.prototype, "livemode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", InvoiceSettingsDTO)
], StripeCustomerDTO.prototype, "invoice_settings", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], StripeCustomerDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], StripeCustomerDTO.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], StripeCustomerDTO.prototype, "phone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], StripeCustomerDTO.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], StripeCustomerDTO.prototype, "created", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], StripeCustomerDTO.prototype, "address", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], StripeCustomerDTO.prototype, "tax_ids", void 0);
export class BillingInfoDTO {
    get info() {
        return {
            name: this.customer?.name || "",
            email: this.customer?.email || "",
            phone: this.customer?.phone || "",
            comments: this.customer?.description || "",
            addressLine1: this.customer?.address?.line1 || "",
            addressLine2: this.customer?.address?.line2 || "",
            postalCode: this.customer?.address?.postal_code || "",
            city: this.customer?.address?.city || "",
            vatId: this.customer?.tax_ids?.data?.[0]?.value || "",
            billingMode: this.billingMode,
            hogastUnionId: this.hogastUnionId,
            hogastMemberId: this.hogastMemberId,
            numberOfEmployees: this.numberOfEmployees,
        };
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BillingInfoDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], BillingInfoDTO.prototype, "invoices", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BillingInfoDTO.prototype, "customer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BillingInfoDTO.prototype, "customerId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], BillingInfoDTO.prototype, "paymentMethods", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], BillingInfoDTO.prototype, "billingMode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BillingInfoDTO.prototype, "hogastUnionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BillingInfoDTO.prototype, "hogastMemberId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BillingInfoDTO.prototype, "numberOfEmployees", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BillingInfoDTO.prototype, "minNumOfBillableEmployees", void 0);
//# sourceMappingURL=billing.dto.js.map